import { render, staticRenderFns } from "./RegistrationListItem.vue?vue&type=template&id=034a7ddb&scoped=true&"
import script from "./RegistrationListItem.vue?vue&type=script&lang=js&"
export * from "./RegistrationListItem.vue?vue&type=script&lang=js&"
import style0 from "./RegistrationListItem.vue?vue&type=style&index=0&id=034a7ddb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "034a7ddb",
  null
  
)

export default component.exports